// Button styles
export const BUTTON_STYLE = {
  outline: 'none',
  '&:focus': {
    outline: 'none'
  }
};

// Dialog styles
export const DIALOG_CLOSE_BUTTON_STYLE = {
  position: 'absolute',
  right: 8,
  top: 8
};

// Table styles
export const COLUMN_MIN_SIZE = 100;
export const COLUMN_SIZE = 120;

// Dialog sizes
export const DIALOG_MAX_WIDTH = '1400px';

// Responsive dialog paper – use in Dialog PaperProps.sx so dialogs size by viewport (including nested)
export const RESPONSIVE_DIALOG_PAPER_PROPS = {
  width: '100vw',
  maxWidth: 1200,
  maxHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
};

/** Near-fullscreen dialog footprint — aligned with Sales Orders nested dialogs (96vw × 92vh). */
export const NEAR_FULLSCREEN_DIALOG_PAPER_SX = {
  width: '96vw',
  maxWidth: '96vw',
  height: '92vh',
  maxHeight: '92vh',
  display: 'flex',
  flexDirection: 'column',
};

// Button variants and sizes
export const BUTTON_VARIANT = 'outlined';
export const BUTTON_SIZE = 'small'; 